package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initApr22023StrAIberryCalendarChallengePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/apr22023StrAIberryCalendarChallenge.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/apr22023-str-a-iberry-calendar-challenge")
@Composable
fun Apr22023StrAIberryCalendarChallengePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("apr-2-2023-straiberry-calendar-challenge") }) {
        org.jetbrains.compose.web.dom.Text("apr-2-2023-StrAIberry-Calendar-Challenge")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We decided to impl a new user story for reminding users on dental events like brushing or dentist appointments. A local calendar system was much needed.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The calendar itself was not much of a challenge, what makes it more complex is the recurring system for reminders. A reminder system usually gives user a couple of options to store recurring events such as repeat everyday, once a week or etc. Now when user modifies a repeatable event, following scenarios might happen:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Edit/Delete only current day")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Edit/Delete This and following events")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Edit/Delete All events")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Obviously the solution is not creating a record for each recurring event, So i start to R&D for a better solution and then I came across this amazing article that explains very clearly.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("href", "https://github.com/bmoeskau/Extensible/blob/master/recurrence-overview.md")}) {
            org.jetbrains.compose.web.dom.Text("recurrence-overview")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We ended up with the following data structure. Each field should explain itself very well:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""/**
 * Stores specific modifications or settings for an event instance.
 * Useful for tracking changes to recurring events or custom event behaviors.
 */
data class EventConfig(
    val parentId: String?,
    /** The date of the edit or configuration change. */
    val editDate: Date,
    /** Unique ID for the specific edited event. */
    val editEventId: String
)

data class EventModel(
    @PrimaryKey val remoteId: String,
    val title: String,
    var eventColor: EventColor,
    var startdDate: Date,
    /** if its null then forever **/
    val endDate: Date? = null,
    val minute: Int,
    val hour: Int,
    val am_pm: String,
    val repetition: EventRepetition,
    val doneDates: ArrayList<Date> = ArrayList(),
    val configs: ArrayList<EventConfig> = ArrayList()
)
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For editing/deleting event that has a repetition we use the following idea:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("When user wants to edit/delete [OnlyThisEvent] we create a new event with edited inputs and update current ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("config")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("When user wants to edit/delete [ThisAndFutureEvent] we create a new event with edited inputs and update current ")
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("endDate")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("When user wants to edit/delete [AllEventInSeries] we just update current event.")
            }
        }
    }
}
